import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class getUserFavorites extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'get user favorites';
        this.Config   = new AppConfig();
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getUserFavorites);
    }

    //Parse successful response
    onSuccess() {
        this.updateState();
    }

    //Dispatch actions to update redux state
    updateState() {
        this.dispatch(Actions.setUserFavorites(this.response.data));
    }
}


export default getUserFavorites;